import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { exportApplicationDataSaga } from "./exportApplicationDataSaga";

const exportModule = (): Module => ({
	id: "ExportModule",
	sagas: () => [exportApplicationDataSaga]
});

export default exportModule;
